import { Component, OnInit } from '@angular/core'
import { CpmService } from '../../../service/cpm.service'
import { StoreService } from '../../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-par-change',
  templateUrl: './par-change.component.html',
  styleUrls: ['./par-change.component.scss']
})
export class ParChangeComponent implements OnInit {
  listHeadParChange
  listTableParChange = []
  subscription: Subscription
  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.listHeadParChange = [
      'Effective date',
      'Old par (Baht)',
      'New par (Baht)'
    ]
    const { symbol } = this.activatedRoute.snapshot.params
    if (symbol !== undefined) {
      this.getParChangeData(symbol)
    } else {
      this.subscription = this.store
        .getSecurityProfileNewResultObservable()
        .subscribe(response => {
          if (!response) {
            return
          }
          this.getParChangeData(response['securitySymbol'])
        })
    }
  }

  getParChangeData(symbol) {
    this.cpmService.getParChange(symbol).then(obj => {
      this.listTableParChange = []
      obj.map(data => {
        this.listTableParChange.push(data)
      })
    })
  }

  noParChangeData() {
    return this.listTableParChange.length > 0 ? false : true
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/corporate-action/par-change/par-change.component.ts